export default {
  title: 'Panier',
  buttons: {
    login_to_checkout: 'Se connecter pour payer',
    checkout: 'Paiement',
  },
  go_to_menu: 'Voir le menu',
  toasts: {
    cashback_points_removed: 'Ton solde de points a changé, nous avons donc retiré les points de cette commande.',
  },
};
